<div class="card estacao-container" style="display: flex; flex-direction: column; height: 100%; overflow: auto;">

    <p-toolbar styleClass="mb-4" [style]="{ 'flex-shrink': '0' }">


        <div class="formgrid p-fluid grid col-12" style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px;">
            <p-multiSelect [options]="dropDownGrupos" appendTo="body" [filter]="true" [(ngModel)]="grupo"
                optionLabel="label" placeholder="Grupos">
            </p-multiSelect>

            <p-multiSelect [options]="dropDownClientes" appendTo="body" [filter]="true" [(ngModel)]="cliente"
                optionLabel="label" placeholder="Cliente">
            </p-multiSelect>

            <p-multiSelect [options]="dropDownSensores" appendTo="body" [filter]="true" [(ngModel)]="sensor"
                optionLabel="label" placeholder="Sensores (Identificador)">
            </p-multiSelect>

            <p-multiSelect [options]="dropDownEstacoesFiltro" appendTo="body" [filter]="true" filterLocale="pt-BR" [(ngModel)]="estacoesFiltro"
                optionLabel="label" placeholder="Estações">
            </p-multiSelect>

            <button pButton pRipple pTooltip="Filtrar" (click)="filtrar()" type="button" icon="pi pi-search"
                class="p-button-rounded p-button-success"></button>

            <input type="text" placeholder="PLU" [(ngModel)]="plu_filtro" pInputText>

            <input type="text" placeholder="FLU" [(ngModel)]="flu_filtro" pInputText>
            <p-multiSelect [options]="dropDownIntegradores" appendTo="body" [filter]="true"
                [(ngModel)]="integrador_filtro" optionLabel="label" placeholder="Integrador">
            </p-multiSelect>
            <p-multiSelect [options]="dropDownColetores" appendTo="body" [filter]="true"
                [(ngModel)]="coletor_filtro" optionLabel="descricao" placeholder="Coletor">
            </p-multiSelect>

            <button pButton pRipple type="button" label="Novo grupo de estação" (click)="addNovoGrupo()"
                icon="pi pi-plus" class="p-button-success"
                [disabled]="!isUsuarioInterno || permissaoService.can('estacoes_inserir') == false"></button>

            <button pButton pRipple label="Nova Estação"
                [disabled]="!isUsuarioInterno || permissaoService.can('estacoes_inserir') == false" icon="pi pi-plus"
                class="p-button-success mr-2" (click)="openNew()"></button>

            <button pButton pRipple type="button" label="Gerar Relatório" icon="pi pi-file-excel"
                class="p-button-info" (click)="exportarRelatorio()" [disabled]="!data || data.length === 0">
            </button>
        </div>


    </p-toolbar>

    <div class="estacao-table-wrapper" #tableWrapper>
        <p-table #dt [value]="data" styleClass="p-datatable-gridlines p-datatable-responsive-demo"
            [paginator]="true" [rowHover]="true" dataKey="id"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} registros" [showCurrentPageReport]="true"
            [lazy]="true" (onLazyLoad)="onGridLazyLoad($event)" [totalRecords]="totalRecords"
            [rows]="perPage" [first]="gridFirst" [loading]="loading"
            [scrollable]="true" [scrollHeight]="scrollHeight">


        <ng-template pTemplate="caption">
            <div class="flex p-flex-column p-flex-md-row align-items-center justify-content-between">
                <h5 class="p-m-0">Estações</h5>
                <span class="p-input-icon-left mt-2 md:mt-0">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" [ngModel]="searchTerm" (input)="onSearchInput($event.target.value)"
                        placeholder="Pesquisar por descrição ou código..." />
                </span>
            </div>

        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th>Código
                </th>
                <th>Descrição
                </th>
                <th class="col-cliente">
                    Cliente
                </th>
                <th class="col-codigo-curto">PLU
                </th>
                <th class="col-codigo-curto">FLU
                </th>
                <th>Editar</th>

            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-dt>
            <tr>
                <td><span class="p-column-title negrito">Código: </span>{{dt.id}}</td>
                <td><span class="p-column-title negrito">Descrição: </span>{{dt.descricao}}</td>
                <td class="col-cliente"><span class="p-column-title negrito">Cliente: </span>{{dt.cliente?.nome}}</td>
                <td class="col-codigo-curto">
                    <span class="p-column-title negrito">PLU: </span>
                    <a
                        *ngIf="dt.plu"
                        href="#"
                        class="link-codigo-externo"
                        title="Abrir série histórica no SNIRH com o código PLU"
                        (click)="abrirSerieHistoricaSnirh(dt.plu, 'PLU'); $event.preventDefault()"
                    >
                        {{dt.plu}}
                    </a>
                </td>
                <td class="col-codigo-curto">
                    <span class="p-column-title negrito">FLU: </span>
                    <a
                        *ngIf="dt.flu"
                        href="#"
                        class="link-codigo-externo"
                        title="Abrir série histórica no SNIRH com o código FLU"
                        (click)="abrirSerieHistoricaSnirh(dt.flu, 'FLU'); $event.preventDefault()"
                    >
                        {{dt.flu}}
                    </a>
                </td>


                <td style="text-align: center;">
                    <span class="p-column-title negrito">Ações: </span>
                    <button pButton pRipple [disabled]="permissaoService.can('estacoes_editar') == false || idEstacaoCarregando !== null"
                        [icon]="isUsuarioInterno ? 'pi pi-pencil' : 'pi pi-eye'"
                        [loading]="idEstacaoCarregando === dt.id"
                        class="p-button-rounded p-button-primary mr-2"
                        pTooltip="Editar" tooltipPosition="top"
                        (click)="edit(dt)"></button>
                    <button *ngIf="isUsuarioInterno" pButton pRipple
                        [disabled]="permissaoService.can('estacoes_excluir') == false"
                        icon="pi pi-trash" class="p-button-rounded p-button-danger mr-2"
                        pTooltip="Excluir" tooltipPosition="top"
                        (click)="excluir(dt)"></button>
                    <button pButton pRipple
                        icon="pi pi-refresh" class="p-button-rounded p-button-info"
                        pTooltip="Reprocessar" tooltipPosition="top"
                        (click)="abrirModalReprocessamento(dt)"></button>
                </td>



            </tr>
        </ng-template>

    </p-table>
    </div>
</div>
<p-dialog [header]="form.get('id')?.value ? (form.get('id')?.value + ' - ' + form.get('descricao')?.value) : 'Nova estação'" [(visible)]="displayModal" [modal]="true" [breakpoints]="{'960px': '75vw'}"
    [style]="{width: '75vw', height: '800px'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false" (onHide)="onDialogEstacaoHide()">
    <div [ngStyle]="{'margin': '7px'}">
        <p-tabView [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event)">
            <p-tabPanel header="Dados principais">
                <form [formGroup]="form" class="p-fluid grid">

                    <div class="field col-12 md:col-12 xl:col-2">
                        <input type="checkbox" class="form-check-input" id="ativo" formControlName="ativo" [disabled]="isViewMode">
                        <label class="form-check-label" for="ativo">Ativo</label>
                    </div>
                    <div class="field col-12 md:col-12 xl:col-2">
                        <input type="checkbox" class="form-check-input" id="estacao_monitorada_api" formControlName="estacao_monitorada_api" [disabled]="isViewMode">
                        <label class="form-check-label" for="estacao_monitorada_api">Estação Combinada API</label>
                    </div>
                    <div class="field field-label-top col-12 md:col-12 xl:col-12">
                        <label for="descricao">Descrição</label>
                        <input type="text" id="descricao" pInputText formControlName="descricao" [disabled]="isViewMode">
                        <small class="p-error">Descrição é obrigatório.</small>
                    </div>

                    <div class="field field-label-top col-12 md:col-12 xl:col-8">
                        <label for="cliente_id">Cliente</label>
                        <p-select
                            inputId="cliente_id"
                            formControlName="cliente_id"
                            [options]="dropDownClientes"
                            optionLabel="label"
                            optionValue="value"
                            [filter]="true"
                            filterBy="label"
                            filterPlaceholder="Buscar..."
                            placeholder="Selecione o cliente"
                            [autoDisplayFirst]="false"
                            appendTo="body"
                            styleClass="w-full"
                            [disabled]="isViewMode">
                            <ng-template #selectedItem let-selectedOption>
                                <span *ngIf="selectedOption">{{ selectedOption.label }}</span>
                            </ng-template>
                            <ng-template let-cliente #item>
                                <span>{{ cliente.label }}</span>
                            </ng-template>
                        </p-select>
                        <small class="p-error">Cliente é obrigatório.</small>
                    </div>

                    <div class="field field-label-top col-12 md:col-12 xl:col-2">
                        <label for="sensor_id">Identif. Transmissor</label>
                        <input type="text" id="sensor_id" pInputText
                            [value]="transmissorIdentificador" disabled class="w-full">
                    </div>

                    <div class="field field-label-top col-12 md:col-12 xl:col-2">
                        <label for="data_instalacao">Data da instalação</label>
                        <input type="date" id="data_instalacao" pInputText formControlName="data_instalacao" [disabled]="isViewMode" class="w-full">
                        <small class="p-error">Data da instalação é obrigatório.</small>
                    </div>

                    <div class="field field-label-top col-12 md:col-12 xl:col-12">
                        <label for="localizacao">Localização</label>
                        <input type="text" id="localizacao" pInputText formControlName="localizacao" [disabled]="isViewMode">
                        <small class="p-error">Localização é obrigatório.</small>
                    </div>

                    <div class="field field-label-top col-12 md:col-12 xl:col-3">
                        <label for="latitude">Latitude</label>
                        <input type="text" id="latitude" pInputText formControlName="latitude" [disabled]="isViewMode">
                        <small class="p-error">Latitude é obrigatório.</small>
                    </div>

                    <div class="field field-label-top col-12 md:col-12 xl:col-3">
                        <label for="longitude">Longitude</label>
                        <input type="text" id="longitude" pInputText formControlName="longitude" [disabled]="isViewMode">
                        <small class="p-error">Longitude é obrigatório.</small>
                    </div>

                    <div class="field col-12 md:col-12 xl:col-3" style="display: none;">
                        <input type="text" id="tipo_integracao" pInputText formControlName="tipo_integracao" [disabled]="isViewMode">
                    </div>

                    <div class="field field-label-top col-12 md:col-12 xl:col-2">
                        <label for="plu">PLU</label>
                        <input type="text" id="plu" pInputText formControlName="plu" [disabled]="isViewMode">
                        <small class="p-error">PLU é obrigatório.</small>
                    </div>

                    <div class="field field-label-top col-12 md:col-12 xl:col-2">
                        <label for="flu">FLU</label>
                        <input type="text" id="flu" pInputText formControlName="flu" [disabled]="isViewMode">
                        <small class="p-error">FLU é obrigatório.</small>
                    </div>

                    <div class="field field-label-top col-12 md:col-12 xl:col-2">
                        <label for="intervalo_operacao">Intervalo de operação (min)</label>
                        <p-inputNumber inputId="intervalo_operacao" formControlName="intervalo_operacao"
                            [disabled]="isViewMode" [min]="5" [max]="9999" [showButtons]="false"
                            styleClass="w-full" placeholder="Ex: 5, 15, 30, 60, 120...">
                        </p-inputNumber>
                        <small *ngIf="form.get('intervalo_operacao')?.hasError('intervaloInvalido')" class="p-error">
                            Aceita apenas: 5, 15, 30 minutos ou múltiplos de 60 (60, 120, 180, etc.)
                        </small>
                    </div>
<!-- 
                    <div class="p-fluid grid col-12">
                        <div class="col-12 ">
                            <hr>
                        </div>

                        <div class="field col-12 md:col-12 xl:col-3">
                            <p-floatlabel>
                                <input type="text" id="tipo_variavel_id" pInputText value="VAZÃO" [disabled]="true">
                                <label for="tipo_variavel_id">Tipo variavel</label>
                            </p-floatlabel>
                        </div>
    
                        <div class="field col-12 md:col-12 xl:col-2">
                            <p-floatlabel>
                                <p-inputNumber formControlName="vazao_x" [disabled]="!exibir_vazao" inputId="vazao_x"  mode="decimal" [minFractionDigits]="1"
                                    [maxFractionDigits]="8">
                                </p-inputNumber>
                                <label for="vazao_x">Vazão X</label>
                            </p-floatlabel>
                        </div>
                        <div class="field col-12 md:col-12 xl:col-2">
                            <p-floatlabel>
                                <p-inputNumber formControlName="vazao_y" [disabled]="!exibir_vazao" inputId="vazao_y" mode="decimal" [minFractionDigits]="1"
                                    [maxFractionDigits]="8">
                                </p-inputNumber>
                                <label for="vazao_y">Vazão Y</label>
                            </p-floatlabel>
                        </div>
                        <div class="field col-12 md:col-12 xl:col-2">
                            <p-floatlabel>
                                <p-inputNumber formControlName="vazao_z" [disabled]="!exibir_vazao" inputId="vazao_z" mode="decimal" [minFractionDigits]="1"
                                    [maxFractionDigits]="8">
                                </p-inputNumber>
                                <label for="vazao_z">Vazão Z</label>
                            </p-floatlabel>
                        </div>
    
                        <div class="field col-12 md:col-12 xl:col-2">
                            <input type="checkbox" class="form-check-input" id="exibir_vazao" formControlName="exibir_vazao">
                            <label class="form-check-label" for="exibir_vazao">Exibir vazão</label>
                        </div>
    
    
                    </div>                     -->

                </form>
            </p-tabPanel>
            <p-tabPanel header="Configurações evento">
                
                <div *ngFor="let item of array_config; let i = index" class="p-fluid grid col-12">
                    <div class="p-fluid grid col-12">


                        <div class="field field-label-top col-12 md:col-12 xl:col-3">
                            <label for="configuracao_evento_id">Configuração evento</label>
                            <p-dropdown inputId="configuracao_evento_id" [disabled]="true"
                                (onChange)="changeConfiguracao(item)" appendTo="body" [filter]="true"
                                styleClass="w-full" [options]="dropDownConfiguracaoEvento" [(ngModel)]="item.configuracao_evento_id">
                            </p-dropdown>
                        </div>

                        <div class="field field-label-top col-12 md:col-12 xl:col-2">
                            <label [for]="'evento_ativo_' + i">Evento ativo</label>
                            <div class="flex align-items-center gap-2">
                                <p-toggleswitch [inputId]="'evento_ativo_' + i" [(ngModel)]="item.ativo"
                                    [disabled]="isViewMode">
                                </p-toggleswitch>
                                <span>{{ item.ativo ? 'Ativo' : 'Inativo' }}</span>
                            </div>
                        </div>

                        <div *ngIf="item.configuracao_evento_id != 6" class="field field-label-top col-12 md:col-12 xl:col-5">
                            <label for="criterio_diario">
                                <ng-container *ngIf="item.configuracao_evento_id == 1">Máximo de eventos com bateria baixa por dia</ng-container>
                                <ng-container *ngIf="item.configuracao_evento_id == 2">Mínimo de leituras com boa potência por dia</ng-container>
                                <ng-container *ngIf="item.configuracao_evento_id == 3">Máximo de eventos com nível travado por dia</ng-container>
                                <ng-container *ngIf="item.configuracao_evento_id == 4">Máximo de eventos com nível oscilante por dia</ng-container>
                                <ng-container *ngIf="item.configuracao_evento_id == 5">Máximo de eventos com nível oscilante por dia</ng-container>
                                <ng-container *ngIf="item.configuracao_evento_id == 7">Mínimo de registros no dia</ng-container>
                                <ng-container *ngIf="item.configuracao_evento_id == 8">Critério diário</ng-container>
                            </label>
                            <input type="number" id="criterio_diario" [disabled]="isViewMode || item.recalculo == false"
                                pInputText [(ngModel)]="item.criterio_diario">
                        </div>

                        <div *ngIf="item.configuracao_evento_id == 6" class="field field-label-top col-12 md:col-12 xl:col-2">
                            <label for="quantidade_anterior_acumular">Horas acumuladas</label>
                            <input type="text" id="quantidade_anterior_acumular"
                                [disabled]="isViewMode || item.recalculo == false" pInputText
                                [(ngModel)]="item.quantidade_anterior_acumular">
                        </div>

                        <div *ngIf="item.configuracao_evento_id == 1 || item.configuracao_evento_id == 2 || item.configuracao_evento_id == 4"
                            class="field field-label-top col-12 md:col-12 xl:col-2">
                            <label for="valor_parametro">Valor parametro</label>
                            <p-inputNumber inputId="valor_parametro" [(ngModel)]="item.valor_parametro"
                                [disabled]="isViewMode || item.recalculo == false" styleClass="w-full"
                                [mode]="'decimal'" [locale]="'pt-BR'" [minFractionDigits]="2" [maxFractionDigits]="2">
                            </p-inputNumber>
                        </div>

                        <div *ngIf="item.configuracao_evento_id == 5" class="field field-label-top col-12 md:col-12 xl:col-2">
                            <label for="valor_minimo">Valor mínimo</label>
                            <p-inputNumber [(ngModel)]="item.valor_minimo" [disabled]="isViewMode || item.recalculo == false"
                                inputId="valor_minimo" styleClass="w-full" mode="decimal" [minFractionDigits]="1" [maxFractionDigits]="5">
                            </p-inputNumber>
                        </div>

                        <div *ngIf="item.configuracao_evento_id == 5" class="field field-label-top col-12 md:col-12 xl:col-2">
                            <label for="valor_maximo">Valor máximo</label>
                            <p-inputNumber [(ngModel)]="item.valor_maximo" [disabled]="isViewMode || item.recalculo == false"
                                inputId="valor_maximo" styleClass="w-full" mode="decimal" [minFractionDigits]="1" [maxFractionDigits]="5">
                            </p-inputNumber>
                        </div>

                        <div *ngIf="item.recalculo !== null" class="field col-12 md:col-12 xl:col-2">
                            <input type="checkbox" class="form-check-input" id="recalculo" [(ngModel)]="item.recalculo">
                            <label class="form-check-label" for="recalculo">Recalculo</label>
                        </div>

                        <div class="col-12 ">
                            <hr>
                        </div>

                    </div>
                </div>

                <!-- <div class="col-12 md:col-12 xl:col-4">
                    <button pButton pRipple icon="pi pi-plus" (click)="addConfig()" label="Inserir configuração"
                        type="button" class="p-button-raised p-text-bold btn-lg p-button-success"></button>
                </div> -->
            </p-tabPanel>
            <p-tabPanel header="Configurações coleta">

                <div [formGroup]="form" class="p-fluid grid col-12 mb-3">
                    <div class="field col-12 md:col-12 xl:col-4 flex align-items-center gap-2">
                        <p-toggleswitch inputId="desativar_coleta" formControlName="desativar_coleta" [disabled]="isViewMode"
                            (onChange)="onDesativarColetaChange()"></p-toggleswitch>
                        <label for="desativar_coleta" class="mb-0">Desativar coleta</label>
                    </div>
                    <div class="col-12">
                        <p-message severity="info">
                            Ao marcar esta opção, a coleta desta estação será desativada. Os demais campos desta aba ficarão bloqueados, mas os valores informados serão mantidos.
                        </p-message>
                    </div>
                </div>

                <div *ngFor="let item of array_config_coleta; let i = index" class="p-fluid grid col-12">
                    <div class="p-fluid grid col-12">

                        <div class="field field-label-top col-12 md:col-12 xl:col-5">
                            <label [attr.for]="'configuracao_coleta_id_' + i">Configuração coleta</label>
                            <p-dropdown [inputId]="'configuracao_coleta_id_' + i" (onChange)="changeConfiguracaoColeta(item)" appendTo="body" [filter]="true"
                                [options]="dropDownColetas" [(ngModel)]="item.configuracao_coleta_id" [disabled]="camposColetaDesabilitados"
                                optionLabel="label" optionValue="value" styleClass="w-full">
                            </p-dropdown>
                        </div>

                        <div class="field field-label-top col-12 md:col-12 xl:col-5">
                            <label [attr.for]="'tipo_descodificacao_id_' + i">Tipo de descodificação</label>
                            <p-dropdown [inputId]="'tipo_descodificacao_id_' + i" appendTo="body" [filter]="true"
                                [options]="dropDownTipoDescodificacao" [(ngModel)]="item.tipo_descodificacao_id" [disabled]="camposColetaDesabilitados"
                                optionLabel="label" optionValue="value" styleClass="w-full">
                            </p-dropdown>
                        </div>

                        <div class="field field-label-top col-12 md:col-12 xl:col-2" *ngIf="isTipoColetaId2(item)">
                            <label [attr.for]="'arquivo_ftp_padrao_' + i">Nome do arquivo</label>
                            <input type="text" [id]="'arquivo_ftp_padrao_' + i" pInputText [(ngModel)]="item.arquivo_ftp_padrao" [disabled]="camposColetaDesabilitados" class="w-full">
                        </div>

                    </div>
                </div>

                <div *ngFor="let item of array_estacao_coletas" class="p-fluid grid col-12">
                    <div class="p-fluid grid col-12">

                        <div class="field field-label-top col-12 md:col-12 xl:col-4">
                            <label for="tipo_variavel_id">Tipo variável</label>
                            <p-dropdown inputId="tipo_variavel_id" appendTo="body" [disabled]="true"
                                styleClass="w-full" [options]="dropDownTipoVariavel" [(ngModel)]="item.tipo_variavel_id">
                            </p-dropdown>
                        </div>

                        <div class="field field-label-top col-12 md:col-12 xl:col-2">
                            <label for="fator_ajuste">Fator ajuste (Multiplicação)</label>
                            <p-inputNumber [(ngModel)]="item.fator_ajuste" [disabled]="camposColetaDesabilitados || item.recalculo == false"
                                inputId="fator_ajuste" styleClass="w-full" mode="decimal" [minFractionDigits]="1" [maxFractionDigits]="5">
                            </p-inputNumber>
                        </div>

                        <div class="field field-label-top col-12 md:col-12 xl:col-2">
                            <label for="acrescimo_decrecimo_ajuste">Acréscimo/decréscimo ajuste</label>
                            <p-inputNumber [(ngModel)]="item.acrescimo_decrecimo_ajuste"
                                [disabled]="camposColetaDesabilitados || item.recalculo == false" inputId="acrescimo_decrecimo_ajuste"
                                styleClass="w-full" mode="decimal" [minFractionDigits]="1" [maxFractionDigits]="5">
                            </p-inputNumber>
                        </div>

                        <div class="field field-label-top col-12 md:col-12 xl:col-2">
                            <label for="casas_decimais">Casas decimais</label>
                            <p-inputNumber [(ngModel)]="item.casas_decimais"
                                [disabled]="camposColetaDesabilitados" inputId="casas_decimais" styleClass="w-full"
                                mode="decimal" [minFractionDigits]="0" [maxFractionDigits]="0" [min]="0" [max]="10">
                            </p-inputNumber>
                        </div>

                        <div *ngIf="item.recalculo !== null" class="field col-12 md:col-12 xl:col-2">
                            <input type="checkbox" class="form-check-input" id="recalculo" [(ngModel)]="item.recalculo" [disabled]="camposColetaDesabilitados">
                            <label class="form-check-label" for="recalculo">Recalculo</label>
                        </div>

                        <div class="field col-12 md:col-12 xl:col-2">
                            <input type="checkbox" class="form-check-input" id="visualizar" [(ngModel)]="item.visualizar" [disabled]="camposColetaDesabilitados">
                            <label class="form-check-label" for="visualizar">Visualizar</label>
                        </div>

                        <div class="col-12 ">
                            <hr>
                        </div>

                    </div>
                </div>

            </p-tabPanel>
            <p-tabPanel header="Configurações de integração">
                <div class="p-fluid grid col-12 integracao-config-fields">
                    <div [formGroup]="form" class="col-12 mb-3">
                        <div class="field col-12 md:col-12 xl:col-4 flex align-items-center gap-2">
                            <p-toggleswitch inputId="desativar_integracao" formControlName="desativar_integracao" [disabled]="isViewMode"
                                (onChange)="onDesativarIntegracaoChange()"></p-toggleswitch>
                            <label for="desativar_integracao" class="mb-0">Desativar integração</label>
                        </div>
                        <div class="col-12">
                            <p-message severity="info">
                                Ao marcar esta opção, a integração desta estação será desativada. Os demais campos desta aba ficarão bloqueados, mas os valores informados serão mantidos.
                            </p-message>
                        </div>
                    </div>

                    <div class="field field-label-top col-12 md:col-12 xl:col-3">
                        <label for="nova_integracao_id">Integrador</label>
                        <p-select
                            inputId="nova_integracao_id"
                            [options]="dropDownIntegradores"
                            [(ngModel)]="novaIntegracao.configuracao_estacao_id"
                            [ngModelOptions]="{standalone: true}"
                            optionLabel="label"
                            optionValue="value"
                            [filter]="true"
                            filterBy="label"
                            filterPlaceholder="Buscar..."
                            placeholder="Selecione o integrador"
                            [autoDisplayFirst]="false"
                            appendTo="body"
                            styleClass="w-full"
                            (onChange)="onIntegradorChange($event)"
                            [disabled]="camposIntegracaoDesabilitados">
                            <ng-template #selectedItem let-selectedOption>
                                <span *ngIf="selectedOption">{{ selectedOption.label }}</span>
                            </ng-template>
                            <ng-template let-integrador #item>
                                <span>{{ integrador.label }}</span>
                            </ng-template>
                        </p-select>
                    </div>

                    <div class="field field-label-top col-12 md:col-12 xl:col-3" *ngIf="!integradorSelecionadoEhValeEcos">
                        <label for="usuario_integracao">Usuário</label>
                        <input id="usuario_integracao" type="text" pInputText [(ngModel)]="novaIntegracao.configuracao_usuario_integracao" [ngModelOptions]="{standalone: true}" [disabled]="camposIntegracaoDesabilitados" class="w-full">
                    </div>

                    <div class="field field-label-top col-12 md:col-12 xl:col-3" *ngIf="!integradorSelecionadoEhValeEcos">
                        <label for="senha_integracao">Senha</label>
                        <input id="senha_integracao" type="password" pInputText [(ngModel)]="novaIntegracao.configuracao_senha_integracao" [ngModelOptions]="{standalone: true}" [disabled]="camposIntegracaoDesabilitados" class="w-full">
                    </div>

                    <div class="field field-label-top col-12 md:col-12 xl:col-3" *ngIf="integradorSelecionadoEhValeEcos">
                        <label for="tag_integracao">Tag</label>
                        <input id="tag_integracao" type="text" pInputText [(ngModel)]="novaIntegracao.tag" [ngModelOptions]="{standalone: true}" [disabled]="camposIntegracaoDesabilitados" class="w-full">
                    </div>

                    <div class="field field-label-top field-integracao-acao col-12 md:col-12 xl:col-3">
                        <button pButton pRipple type="button" label="Adicionar" icon="pi pi-plus" 
                            (click)="adicionarIntegracao()" class="p-button-success" 
                            [disabled]="!podeAdicionarIntegracao">
                        </button>
                    </div>

                    <div class="col-12">
                        <p-table [value]="array_integracao" [columns]="cols_integracao" dataKey="configuracao_estacao_id"
                            styleClass="p-datatable-responsive-demo p-datatable-gridlines" [rowHover]="true">
                            
                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th *ngFor="let col of columns" [ngStyle]="{'background-color': '#efefef', 'width': col.field === 'configuracao_estacao_id' ? '30%' : '20%'}">
                                        {{col.header}}
                                    </th>
                                    <th style="background-color: #efefef; width: 20%; text-align: center;">
                                        Ações
                                    </th>
                                </tr>
                            </ng-template>
                    
                            <ng-template pTemplate="body" let-rowData let-columns="columns">
                                <tr>
                                    <td *ngFor="let col of columns" [ngStyle]="{'background-color': 'aliceblue'}">
                                        <span class="p-column-title">{{col.header}}</span>
                                        <ng-container *ngIf="col.field === 'configuracao_estacao_id'">
                                            {{rowData.configuracao_estacao_label}}
                                        </ng-container>
                                        <ng-container *ngIf="col.field === 'tag'">
                                            {{ rowData.tag || '—' }}
                                        </ng-container>
                                        <ng-container *ngIf="col.field === 'configuracao_usuario_integracao'">
                                            {{ rowData.configuracao_usuario_integracao || '—' }}
                                        </ng-container>
                                    </td>
                                    <td style="background-color: aliceblue; text-align: center;">
                                        <button *ngIf="isUsuarioInterno && !camposIntegracaoDesabilitados && !isIntegradorValeEcos(rowData.configuracao_estacao_id)" pButton pRipple icon="pi pi-eye" pTooltip="Visualizar usuário e senha"
                                            class="p-button-rounded p-button-info mr-1"
                                            (click)="abrirVisualizarCredenciais(rowData)">
                                        </button>
                                        <button *ngIf="!camposIntegracaoDesabilitados" pButton pRipple icon="pi pi-trash" pTooltip="Remover"
                                            class="p-button-rounded p-button-danger" 
                                            (click)="removerIntegracao(rowData)">
                                        </button>
                                    </td>
                                </tr>
                            </ng-template>
                    
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td [attr.colspan]="cols_integracao.length + 1" style="text-align: center;">
                                        Nenhuma integração configurada
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </p-tabPanel>
            <p-tabPanel header="Configurações de Vazão">
                <div class="p-fluid grid col-12">
                    <div [formGroup]="form" class="field col-12 flex align-items-center gap-3">
                        <span class="vazao-status" [class.vazao-status-ativo]="exibir_vazao" [class.vazao-status-inativo]="!exibir_vazao">
                            {{ exibir_vazao ? 'Vazão ativa' : 'Vazão inativa' }}
                        </span>
                        <button pButton pRipple type="button"
                            [label]="exibir_vazao ? 'Desativar vazão' : 'Ativar vazão'"
                            [icon]="exibir_vazao ? 'pi pi-pause' : 'pi pi-play'"
                            [ngClass]="exibir_vazao ? 'p-button-warning' : 'p-button-success'"
                            [disabled]="isViewMode" (click)="alternarAtivacaoVazao()">
                        </button>
                        <small class="text-color-secondary">A alteração passa a valer somente após salvar a estação.</small>
                    </div>

                    <div [formGroup]="form" class="field col-12 md:col-12">
                        <label class="mb-2">Origem da vazão</label>
                        <div class="flex p-flex-wrap p-gap-2">
                            <div class="field-radiobutton">
                                <p-radioButton name="tipo_origem_vazao" [value]="0" formControlName="tipo_origem_vazao" inputId="tipo_origem_calculada" [disabled]="isViewMode"></p-radioButton>
                                <label for="tipo_origem_calculada">Vazão calculada</label>
                            </div>
                            <div class="field-radiobutton">
                                <p-radioButton name="tipo_origem_vazao" [value]="1" formControlName="tipo_origem_vazao" inputId="tipo_origem_api" [disabled]="isViewMode"></p-radioButton>
                                <label for="tipo_origem_api">Vazão via API</label>
                            </div>
                        </div>
                    </div>

                    <div [formGroup]="form" class="field field-label-top col-12 md:col-12 xl:col-2">
                        <label for="casas_decimais_vazao">Casas decimais</label>
                        <p-inputNumber formControlName="casas_decimais_vazao" inputId="casas_decimais_vazao"
                            styleClass="w-full" mode="decimal" [minFractionDigits]="0" [maxFractionDigits]="0"
                            [min]="0" [max]="10" [disabled]="isViewMode">
                        </p-inputNumber>
                        <small class="p-error" *ngIf="form.get('casas_decimais_vazao')?.invalid && form.get('casas_decimais_vazao')?.touched">
                            Informe um número inteiro entre 0 e 10.
                        </small>
                    </div>

                    <div class="field col-12 md:col-12" *ngIf="exibirMensagemAlteracaoCalculoVazao">
                        <p-message severity="warn">
                            Ao salvar com <strong>Vazão calculada</strong>, a alteração nas faixas ou na fórmula implicará no cálculo apenas a partir do horário da alteração. Se desejar aplicar a nova fórmula a dados passados, será necessário <strong>Reprocessar o cálculo da vazão da estação</strong>.
                        </p-message>
                    </div>

                    <div class="field col-12 md:col-12 xl:col-2">
                        <div>
                            Q = a × (H - (H0))<sup>n</sup>
                        </div>
                    </div>


                    <div class="p-fluid grid col-12">

                        <div class="field field-label-top col-12 md:col-12 xl:col-2">
                            <label for="intervalo_minimo">Intervalo mínimo</label>
                            <p-inputNumber inputId="intervalo_minimo" styleClass="w-full"
                                mode="decimal" [minFractionDigits]="0" [maxFractionDigits]="0"
                                [(ngModel)]="intervaloMinimo" [disabled]="isViewMode || !exibirCamposCalculoVazao">
                            </p-inputNumber>
                        </div>

                        <div class="field field-label-top col-12 md:col-12 xl:col-2">
                            <label for="intervalo_maximo">Intervalo máximo</label>
                            <p-inputNumber inputId="intervalo_maximo" styleClass="w-full"
                                mode="decimal" [minFractionDigits]="0" [maxFractionDigits]="0"
                                [(ngModel)]="intervaloMaximo" [disabled]="isViewMode || !exibirCamposCalculoVazao">
                            </p-inputNumber>
                        </div>

                        <div class="field field-label-top col-12 md:col-12 xl:col-2">
                            <label for="valor_x">Valor a</label>
                            <p-inputNumber inputId="valor_x" styleClass="w-full"
                                mode="decimal" [minFractionDigits]="1" [maxFractionDigits]="5"
                                [(ngModel)]="valorX" [disabled]="isViewMode || !exibirCamposCalculoVazao">
                            </p-inputNumber>
                        </div>

                        <div class="field field-label-top col-12 md:col-12 xl:col-2">
                            <label for="valor_y">Valor H0</label>
                            <p-inputNumber inputId="valor_y" styleClass="w-full"
                                mode="decimal" [minFractionDigits]="1" [maxFractionDigits]="5"
                                [(ngModel)]="valorY" [disabled]="isViewMode || !exibirCamposCalculoVazao">
                            </p-inputNumber>
                        </div>

                        <div class="field field-label-top col-12 md:col-12 xl:col-2">
                            <label for="valor_z">Valor n</label>
                            <p-inputNumber inputId="valor_z" styleClass="w-full"
                                mode="decimal" [minFractionDigits]="1" [maxFractionDigits]="5"
                                [(ngModel)]="valorZ" [disabled]="isViewMode || !exibirCamposCalculoVazao">
                            </p-inputNumber>
                        </div>

                        <div class="field field-label-top col-2">
                            <label>&nbsp;</label>
                            <button pButton pRipple type="button" label="Inserir" icon="pi pi-arrow-down" iconPos="right"
                                (click)="adicionarVazao()" class="p-button-raised mr-2" style="background-color: #ADD8E6; border-color: #ADD8E6; color: #000;"
                                [disabled]="isViewMode || !exibirCamposCalculoVazao">
                            </button>
                        </div>
            
                        <div class="field col-12">
                            <p-table [value]="array_vazao" [columns]="cols_vazao" dataKey="id" [rows]="rows"
                            styleClass="p-datatable-responsive-demo p-datatable-gridlines" [rowHover]="true">
                            
                                <!-- Cabeçalho -->
                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th *ngFor="let col of columns" [ngStyle]="getColumnStyle(col.field)">
                                            {{col.header}}
                                        </th>
                                        <th style="background-color: #efefef; width: 10%; text-align: center;">
                                            Remover
                                        </th>
                                    </tr>
                                </ng-template>
                        
                                <!-- Corpo -->
                                <ng-template pTemplate="body" let-rowData let-columns="columns">
                                    <tr>
                                        <td *ngFor="let col of columns" [ngStyle]="getColumnStyleBody(col.field)">
                                            <span class="p-column-title">{{col.header}}</span>
                                            
                                            <!-- Verificar se o campo é "visualizacao_formula" -->
                                            <ng-container *ngIf="col.field === 'visualizacao_formula'; else normalText">
                                                Q = {{rowData['valor_x']}} × (H - ({{rowData['valor_y']}}))<sup>{{rowData['valor_z']}}</sup>
                                            </ng-container>
                                
                                            <!-- Caso não seja o campo operação, exibe normalmente -->
                                            <ng-template #normalText>
                                                {{rowData[col.field]}}
                                            </ng-template>
                                        </td>
                                        <td style="background-color: aliceblue; text-align: center;">
                                            <button pButton pRipple icon="pi pi-trash" pTooltip="Remover Vazão"
                                                class="p-button-rounded p-button-danger" (click)="removeVazao(rowData)"
                                                [disabled]="isViewMode || !exibirCamposCalculoVazao">
                                            </button>
                                        </td>
                                    </tr>
                                </ng-template>
                        
                            </p-table>
                        </div>

                        <div class="field col-12 mt-4">
                            <h5>Histórico de configurações</h5>
                            <p-progressSpinner *ngIf="historicoVazaoLoading"
                                [style]="{width: '40px', height: '40px'}" strokeWidth="4">
                            </p-progressSpinner>

                            <p-message *ngIf="!historicoVazaoLoading && !historicoVazaoErro && !historicoVazaoIndisponivel && historicoVazaoCarregado && historicoVazao.length === 0"
                                severity="info" text="Ainda não há configurações futuras registradas no histórico.">
                            </p-message>

                            <div *ngIf="historicoVazaoIndisponivel" class="flex align-items-center gap-2 mb-3">
                                <span class="text-color-secondary">O histórico ficará disponível após a atualização do servidor.</span>
                                <button pButton pRipple type="button" label="Tentar novamente" icon="pi pi-refresh"
                                    class="p-button-sm p-button-outlined" (click)="carregarHistoricoVazao(historicoVazaoPagina)">
                                </button>
                            </div>

                            <div *ngIf="historicoVazaoErro" class="flex align-items-center gap-2 mb-3">
                                <span class="p-error">Não foi possível carregar o histórico.</span>
                                <button pButton pRipple type="button" label="Tentar novamente" icon="pi pi-refresh"
                                    class="p-button-sm p-button-outlined" (click)="carregarHistoricoVazao(historicoVazaoPagina)">
                                </button>
                            </div>

                            <p-table *ngIf="!historicoVazaoLoading && historicoVazao.length > 0"
                                [value]="historicoVazao" styleClass="p-datatable-responsive-demo p-datatable-gridlines">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Data</th>
                                        <th>Usuário</th>
                                        <th>Status</th>
                                        <th>Origem</th>
                                        <th>Casas decimais</th>
                                        <th>Faixas</th>
                                        <th style="width: 9rem; text-align: center;">Ação</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item>
                                    <tr>
                                        <td>{{ formatarDataHora(item.created_at) }}</td>
                                        <td>{{ item.usuario?.name || 'Usuário não disponível' }}</td>
                                        <td>{{ item.ativo ? 'Ativa' : 'Inativa' }}</td>
                                        <td>{{ item.tipo_origem_vazao === 1 ? 'API' : (item.tipo_origem_vazao === 0 ? 'Calculada' : '-') }}</td>
                                        <td>{{ item.casas_decimais_vazao ?? '-' }}</td>
                                        <td>
                                            <div *ngFor="let faixa of item.faixas">
                                                {{ faixa.intervalo_inical }}–{{ faixa.intervalo_final }}:
                                                Q = {{ faixa.valor_x }} × (H - {{ faixa.valor_y }})<sup>{{ faixa.valor_z }}</sup>
                                            </div>
                                            <span *ngIf="!item.faixas?.length">Sem faixas</span>
                                        </td>
                                        <td style="text-align: center;">
                                            <button pButton pRipple type="button" label="Reutilizar" icon="pi pi-history"
                                                class="p-button-sm p-button-outlined" [disabled]="isViewMode"
                                                (click)="reutilizarConfiguracaoVazao(item)">
                                            </button>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>

                            <p-paginator *ngIf="historicoVazaoTotal > historicoVazaoPorPagina"
                                [first]="historicoVazaoFirst" [rows]="historicoVazaoPorPagina"
                                [totalRecords]="historicoVazaoTotal" [rowsPerPageOptions]="[10, 20, 50]"
                                (onPageChange)="onHistoricoVazaoPage($event)">
                            </p-paginator>
                        </div>

                        <!-- <div class="col-12 ">
                            <hr>
                        </div> -->
                    </div>
                </div>
            </p-tabPanel>
            <p-tabPanel header="Log Integradores">
                <div class="p-fluid grid col-12">
                    <div *ngIf="loadingLogs" class="flex flex-column align-items-center justify-content-center p-5">
                        <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="4"></p-progressSpinner>
                        <span class="mt-3 text-color-secondary">Carregando logs de integração...</span>
                    </div>

                    <p-table *ngIf="!loadingLogs" #dtLogs [value]="logs" [rows]="rowsLogs" styleClass="p-datatable-gridlines p-datatable-responsive-demo"
                        [paginator]="true" [rowHover]="true" dataKey="id"
                        currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} registros" [showCurrentPageReport]="true"
                        [globalFilterFields]="['id','integracao_id', 'mensagens', 'status_code']"
                        [totalRecords]="logsTotalRecords" (onPage)="onPageChange($event)"
                        [lazy]="true">

                        <!-- <ng-template pTemplate="caption">
                            <div class="flex align-items-center justify-content-between">
                                <h5 class="p-m-0">Log Execução Integração</h5>
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                                        placeholder="Pesquisar..." />
                                </span>
                            </div>
                        </ng-template> -->

                        <ng-template pTemplate="header">
                            <tr>
                                <th>Código</th>
                                <th>Data</th>
                                <th>Código integração</th>
                                <th>Mensagens</th>
                                <th>Código status</th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-log>
                            <tr>
                                <td><span class="p-column-title negrito">Código: </span>{{log.id}}</td>
                                <td><span class="p-column-title negrito">Data: </span>{{log.data_hora | date: 'dd/MM/yyyy HH:mm'}}</td>
                                <td><span class="p-column-title negrito">Código integração: </span>{{log.integracao_id}}</td>
                                <td><span class="p-column-title negrito">Mensagens: </span>{{log.mensagens}}</td>
                                <td><span class="p-column-title negrito">Código status: </span>{{log.status_code}}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </p-tabPanel>

        </p-tabView>

    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" icon="pi pi-arrow-left" (click)="fecharDialogEstacao()" label="Voltar"
            class="p-button-raised p-button-warning mr-2">
        </button>
        <button *ngIf="loading == false && !isViewMode" pButton pRipple type="button" icon="pi pi-check" (click)="save()"
            label="Salvar" class="p-button-raised p-button-success" [disabled]="form.invalid"></button>
        <p-progressSpinner *ngIf="loading" [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner"
            strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
    </ng-template>
</p-dialog>

<p-dialog
    [header]="snirhSerieHistoricaTitulo"
    [(visible)]="modalSnirhSerieHistorica"
    [modal]="true"
    [dismissableMask]="true"
    [style]="{ width: '95vw' }"
    [contentStyle]="{ 'max-height': '80vh', overflow: 'auto' }">
    <div *ngIf="loadingSnirhSerieHistorica" class="snirh-loading">
        Carregando dados do SNIRH...
    </div>

    <div *ngIf="!loadingSnirhSerieHistorica && snirhSerieHistoricaHtml" class="snirh-resultado">
        <div [innerHTML]="snirhSerieHistoricaHtml"></div>
    </div>
</p-dialog>

<p-dialog header="Recalculo" [(visible)]="modalDataRecalculo" [modal]="true" [breakpoints]="{'960px': '75vw'}"
    [style]="{width: '75vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <div [ngStyle]="{'margin': '7px'}">
        <h5 *ngIf="array_config_copia.length > 0">Configurações evento</h5>
        <div *ngFor="let item of array_config_copia" class="p-fluid grid col-12">
            <div *ngIf="item.ativo == true" class="p-fluid grid col-12">


                <div class="field col-12 md:col-12 xl:col-3">
                    <p-floatlabel>
                        <p-dropdown inputId="configuracao_evento_id" [disabled]="true" appendTo="body" [filter]="true"
                            [options]="dropDownConfiguracaoEvento" [(ngModel)]="item.configuracao_evento_id">
                        </p-dropdown>
                        <label for="configuracao_evento_id">Configuração evento</label>
                    </p-floatlabel>
                </div>


                <!-- <div class="field col-12 md:col-12 xl:col-3">
                    <p-floatlabel>
                        <input type="text" id="frequencia_em_minutos" [disabled]="true" pInputText
                            [(ngModel)]="item.frequencia_em_minutos">
                        <label for="frequencia_em_minutos">Frequência em minutos</label>
                    </p-floatlabel>
                </div> -->
                <div *ngIf="item.configuracao_evento_id !== 1 && item.configuracao_evento_id !== 2 && item.configuracao_evento_id !== 6"
                    class="field col-12 md:col-12 xl:col-2">
                    <p-floatlabel>
                        <input type="number" id="criterio_diario" [disabled]="true" pInputText
                            [(ngModel)]="item.criterio_diario">
                        <label for="criterio_diario">Critério diário</label>
                    </p-floatlabel>
                </div>

                <div *ngIf="item.configuracao_evento_id == 1 || item.configuracao_evento_id == 2"
                    class="field col-12 md:col-12 xl:col-5">
                    <p-floatlabel>
                        <input type="number" id="criterio_diario" [disabled]="true" pInputText
                            [(ngModel)]="item.criterio_diario">
                        <label *ngIf="item.configuracao_evento_id == 1" for="criterio_diario">Máximo de eventos com
                            bateria baixa por dia</label>
                        <label *ngIf="item.configuracao_evento_id == 2" for="criterio_diario">Mínimo de leituras com
                            boa potência por dia</label>
                    </p-floatlabel>
                </div>

                <!-- <div class="field col-12 md:col-12 xl:col-4">
                    <p-floatlabel>
                        <input type="number" id="quantidade_parametro_diario" [disabled]="true" pInputText
                            [(ngModel)]="item.quantidade_parametro_diario">
                        <label for="quantidade_parametro_diario">Quantidade de parametros diário</label>
                    </p-floatlabel>
                </div> -->

                <div *ngIf="item.configuracao_evento_id == 6" class="field col-12 md:col-12 xl:col-2">
                    <p-floatlabel>
                        <input type="text" id="quantidade_anterior_acumular" [disabled]="true" pInputText
                            [(ngModel)]="item.quantidade_anterior_acumular ">
                        <label for="quantidade_anterior_acumular ">Horas acumuladas</label>
                    </p-floatlabel>
                </div>

                <div *ngIf="item.configuracao_evento_id == 1 || item.configuracao_evento_id == 2 || item.configuracao_evento_id == 4 "
                    class="field col-12 md:col-12 xl:col-2">
                    <p-floatlabel>
                        <p-inputNumber [(ngModel)]="item.valor_parametro" [disabled]="true" [mode]="'decimal'"
                            [locale]="'pt-BR'" [minFractionDigits]="2" [maxFractionDigits]="2"></p-inputNumber>

                        <label for="valor_parametro">Valor parametro</label>
                    </p-floatlabel>
                </div>

                <div *ngIf="item.configuracao_evento_id == 5" class="field col-12 md:col-12 xl:col-2">
                    <p-floatlabel>
                        <p-inputNumber [(ngModel)]="item.valor_minimo" [disabled]="true" inputId="valor_minimo"
                            mode="decimal" [minFractionDigits]="1" [maxFractionDigits]="5">
                        </p-inputNumber>
                        <label for="valor_minimo">Valor minimo</label>
                    </p-floatlabel>
                </div>

                <div *ngIf="item.configuracao_evento_id == 5" class="field col-12 md:col-12 xl:col-2">
                    <p-floatlabel>

                        <p-inputNumber [(ngModel)]="item.valor_maximo" [disabled]="true" inputId="valor_maximo"
                            mode="decimal" [minFractionDigits]="1" [maxFractionDigits]="5">
                        </p-inputNumber>
                        <label for="valor_maximo">Valor máximo</label>
                    </p-floatlabel>
                </div>

                <div class="col-12 ">
                    <hr>
                </div>

            </div>
        </div>
        <h5 *ngIf="array_estacao_coletas_copia.length > 0">Configurações coleta</h5>
        <div *ngFor="let item of array_estacao_coletas_copia" class="p-fluid grid col-12">
            <div class="p-fluid grid col-12">


                <div class="field col-12 md:col-12 xl:col-4">
                    <p-floatlabel>
                        <p-dropdown inputId="tipo_variavel_id" appendTo="body" [disabled]="true"
                            [options]="dropDownTipoVariavel" [(ngModel)]="item.tipo_variavel_id">
                        </p-dropdown>
                        <label for="tipo_variavel_id">Tipo variavel</label>
                    </p-floatlabel>
                </div>

                <div class="field col-12 md:col-12 xl:col-3">
                    <p-floatlabel>
                        <p-inputNumber [(ngModel)]="item.fator_ajuste" [disabled]="true" inputId="fator_ajuste"
                            mode="decimal" [minFractionDigits]="1" [maxFractionDigits]="5">
                        </p-inputNumber>
                        <label for="fator_ajuste">Fator ajuste (Multiplicação)</label>
                    </p-floatlabel>
                </div>
                <div class="field col-12 md:col-12 xl:col-3">
                    <p-floatlabel>
                        <p-inputNumber [(ngModel)]="item.acrescimo_decrecimo_ajuste" [disabled]="true"
                            inputId="acrescimo_decrecimo_ajuste" mode="decimal" [minFractionDigits]="1"
                            [maxFractionDigits]="5">
                        </p-inputNumber>
                        <label for="acrescimo_decrecimo_ajuste">Acrescimo decréscimo ajuste</label>
                    </p-floatlabel>
                </div>

                <div class="col-12 ">
                    <hr>
                </div>

            </div>
        </div>
        <h5>Recalcular</h5>
        <div class="p-fluid grid col-12 md:col-12 xl:col-5">
            <label for="data_recalculo">Recalcular a partir</label>
            <input type="date" id="data_recalculo" pInputText [(ngModel)]="dataRecalculo">
        </div>
        <p class="reprocessamento-aviso col-12">
            O recálculo recria os eventos marcados em Configurações evento e aplica o fator das variáveis marcadas em Configurações coleta.
            Pode ser só um dos dois, ou os dois juntos. O processamento segue em background.
            Acompanhe o andamento em Reprocessamento da estação.
        </p>
    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" (click)="modalDataRecalculo = false" label="Não é necessário"
            class="p-button-raised p-button-warning mr-2">
        </button>
        <button *ngIf="loading == false" pButton pRipple type="button" icon="pi pi-check" (click)="saveDataRecalculo()"
            label="Enfileirar recálculo" class="p-button-raised p-button-success"></button>
    </ng-template>
</p-dialog>

<p-dialog [(visible)]="modalNovoGrupo" header="Novo Grupo de estações"
    [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '75vw'}">
    <app-grupo-estacao-formulario (onSave)="aoSalvarNovoGrupo()"></app-grupo-estacao-formulario>
</p-dialog>


<!-- Modal de Reprocessamento de Coleta (período) -->
<p-dialog header="Reprocessar Coleta" [(visible)]="modalReprocessamento" [modal]="true"
    [style]="{width: '50vw', maxWidth: '600px'}" [draggable]="false" [resizable]="false" [closable]="true"
    [dismissableMask]="true">

    <div class="p-fluid grid" *ngIf="estacaoReprocessamento">
        <div class="field col-12">
            <label>Estação</label>
            <input type="text" pInputText [value]="estacaoReprocessamento.descricao" [disabled]="true">
        </div>

        <div class="field col-12">
            <label for="data_hora_reprocessamento" class="reprocessamento-date-label">Data inicial *</label>
            <p-datepicker inputId="data_hora_reprocessamento" [(ngModel)]="dataHoraReprocessamento"
                    [showTime]="false" [showIcon]="true" dateFormat="dd/mm/yy"
                    [minDate]="dataMinima" [maxDate]="dataMaxima"
                    appendTo="body" placeholder="Selecione a data">
            </p-datepicker>
        </div>

        <div class="field col-12">
            <label for="data_final_reprocessamento_coleta" class="reprocessamento-date-label">Data final</label>
            <p-datepicker inputId="data_final_reprocessamento_coleta" [(ngModel)]="dataFinalReprocessamentoColeta"
                    [showTime]="false" [showIcon]="true" dateFormat="dd/mm/yy"
                    [minDate]="dataMinima" [maxDate]="dataMaxima"
                    appendTo="body" placeholder="Opcional (padrão: hoje)">
            </p-datepicker>
            <small class="p-text-secondary">
                O processamento roda em background. Se houver valores alterados, eventos e fechamento do dia serão recalculados.
            </small>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" label="Cancelar" icon="pi pi-times"
            class="p-button-text" (click)="modalReprocessamento = false"></button>
        <button pButton pRipple type="button" label="Próximo" icon="pi pi-arrow-right"
            [disabled]="!dataHoraReprocessamento" (click)="confirmarReprocessamento()"
            class="p-button-primary"></button>
    </ng-template>
</p-dialog>

<!-- Modal de Confirmação de Reprocessamento -->
<p-dialog header="Confirmar Reprocessamento de Coleta" [(visible)]="modalConfirmacaoReprocessamento" [modal]="true"
    [style]="{width: '50vw', maxWidth: '600px'}" [draggable]="false" [resizable]="false" [closable]="true"
    [dismissableMask]="true">

    <div class="p-fluid" *ngIf="estacaoReprocessamento && dataHoraReprocessamento">
        <div class="mb-3">
            <h5>Confirme os dados do reprocessamento:</h5>
        </div>

        <div class="field col-12 mb-3">
            <label class="p-text-bold">Estação:</label>
            <p>{{estacaoReprocessamento.descricao}}</p>
        </div>

        <div class="field col-12 mb-3">
            <label class="p-text-bold">Data Inicial:</label>
            <p>{{dataHoraReprocessamento | date:'dd/MM/yyyy'}}</p>
        </div>

        <div class="field col-12 mb-3" *ngIf="dataFinalReprocessamentoColeta">
            <label class="p-text-bold">Data Final:</label>
            <p>{{dataFinalReprocessamentoColeta | date:'dd/MM/yyyy'}}</p>
        </div>

        <div class="mb-3">
            <p class="p-text-secondary">
                A solicitação será enfileirada e processada em background. Você pode acompanhar o andamento na tela de reprocessamento.
            </p>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" label="Cancelar" icon="pi pi-times"
            class="p-button-text" (click)="modalConfirmacaoReprocessamento = false"></button>
        <button pButton pRipple type="button" label="Enfileirar" icon="pi pi-check"
            [disabled]="loadingReprocessamento" (click)="executarReprocessamento()"
            class="p-button-success"></button>
        <p-progressSpinner *ngIf="loadingReprocessamento" [style]="{width: '35px', height: '35px'}"
            styleClass="custom-spinner" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
    </ng-template>
</p-dialog>

<!-- Painel de Reprocessamento da Estação -->
<p-dialog header="Reprocessamento da Estação" [(visible)]="modalOpcoesReprocessamento" [modal]="true"
    [style]="{width: '70vw', maxWidth: '920px'}" [draggable]="false" [resizable]="false" [closable]="true"
    [dismissableMask]="true" (onHide)="cancelarOpcoesReprocessamento()">

    <div class="p-fluid" *ngIf="estacaoReprocessamento">
        <div class="mb-3">
            <label class="p-text-bold">Estação:</label>
            <p class="mb-2">{{estacaoReprocessamento.descricao}}</p>
            <p class="reprocessamento-aviso">
                Os reprocessamentos rodam em background. Você pode fechar esta janela e voltar depois para ver o andamento.
            </p>
        </div>

        <div class="reprocessamento-acoes mb-4">
            <button pButton pRipple type="button" label="Coleta" icon="pi pi-download"
                (click)="abrirModalReprocessarColetar()" class="p-button-primary"
                [disabled]="temConflitoColetaAtivo()"
                pTooltip="{{ temConflitoColetaAtivo() ? 'Já existe coleta ou recálculo em andamento para esta estação.' : '' }}"
                tooltipPosition="top"></button>
            <button pButton pRipple type="button" label="Integração" icon="pi pi-send"
                (click)="abrirModalReprocessarIntegracao()" class="p-button-success"
                [disabled]="temConflitoIntegracaoAtivo()"
                pTooltip="{{ temConflitoIntegracaoAtivo() ? 'Já existe integração em andamento para esta estação.' : '' }}"
                tooltipPosition="top"></button>
            <button pButton pRipple type="button" label="Valores vazão" icon="pi pi-calculator"
                [disabled]="!podeRecalcularVazaoNivel" (click)="abrirModalRecalcularVazao()"
                class="p-button-info" pTooltip="Disponível apenas para estações com Visualizar vazão e Vazão calculada."
                tooltipPosition="top"></button>
            <button pButton pRipple type="button" label="Atualizar" icon="pi pi-refresh"
                class="p-button-text" (click)="carregarListaReprocessamentos()"
                [disabled]="loadingListaReprocessamentos"></button>
        </div>

        <h5 class="mb-2">Andamento</h5>
        <div *ngIf="loadingListaReprocessamentos && listaReprocessamentos.length === 0" class="p-text-secondary mb-3">
            Carregando...
        </div>
        <div *ngIf="!loadingListaReprocessamentos && listaReprocessamentos.length === 0" class="p-text-secondary mb-3">
            Nenhum reprocessamento recente para esta estação.
        </div>

        <div class="reprocessamento-lista" *ngIf="listaReprocessamentos.length > 0">
            <div class="reprocessamento-item" *ngFor="let item of listaReprocessamentos">
                <div class="reprocessamento-item-header">
                    <div>
                        <span class="reprocessamento-item-tipo">{{ labelTipoReprocessamento(item.tipo) }}</span>
                        <span class="reprocessamento-status-badge"
                            [ngClass]="'status-' + item.status">{{ labelStatusReprocessamento(item.status) }}</span>
                    </div>
                    <small class="p-text-secondary">
                        {{ item.data_inicio | date:'dd/MM/yyyy' }}
                        <span *ngIf="item.data_fim"> — {{ item.data_fim | date:'dd/MM/yyyy' }}</span>
                    </small>
                </div>
                <div class="reprocessamento-item-vars" *ngIf="item.tipo_evento_labels?.length">
                    Eventos: {{ item.tipo_evento_labels.join(', ') }}
                </div>
                <div class="reprocessamento-item-vars" *ngIf="item.tipo_variavel_labels?.length">
                    Variáveis: {{ item.tipo_variavel_labels.join(', ') }}
                </div>
                <div class="reprocessamento-progresso" *ngIf="item.dias_total > 0">
                    <p-progressBar [value]="item.progresso_pct || 0" [showValue]="true"></p-progressBar>
                    <small>{{ item.dias_processados || 0 }} / {{ item.dias_total }} dia(s)</small>
                </div>
                <div class="reprocessamento-item-msg">{{ item.mensagem }}</div>
                <div class="reprocessamento-logs" *ngIf="item.logs?.length">
                    <small *ngFor="let log of logsReprocessamentoPreview(item)" class="reprocessamento-log-line">
                        {{ log.created_at | date:'dd/MM/yyyy HH:mm' }} — {{ log.mensagem }}
                    </small>
                </div>
            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" label="Fechar" icon="pi pi-times"
            class="p-button-text" (click)="cancelarOpcoesReprocessamento()"></button>
    </ng-template>
</p-dialog>

<!-- Modal Recalcular valores do nível (vazão) - data inicial e final, máx 60 dias -->
<p-dialog header="Recalcular valores do nível (vazão)" [(visible)]="modalRecalcularVazao" [modal]="true"
    [style]="{width: '50vw', maxWidth: '600px'}" [draggable]="false" [resizable]="false" [closable]="true"
    [dismissableMask]="true" [closeOnEscape]="!loadingRecalcularVazao">

    <div class="p-fluid grid" *ngIf="estacaoReprocessamento">
        <div class="field col-12 mb-3">
            <label class="p-text-bold">Estação:</label>
            <p>{{estacaoReprocessamento.descricao}}</p>
        </div>

        <div class="field col-12">
            <label for="data_inicial_recalcular_vazao" class="reprocessamento-date-label">Data inicial *</label>
            <p-datepicker inputId="data_inicial_recalcular_vazao" [(ngModel)]="dataInicialRecalcularVazao"
                [showTime]="false" [showIcon]="true" dateFormat="dd/mm/yy"
                [maxDate]="dataMaxima" [minDate]="dataMinima"
                appendTo="body" placeholder="Data inicial (obrigatório)" [disabled]="loadingRecalcularVazao">
            </p-datepicker>
        </div>

        <div class="field col-12">
            <label for="data_final_recalcular_vazao" class="reprocessamento-date-label">Data final *</label>
            <p-datepicker inputId="data_final_recalcular_vazao" [(ngModel)]="dataFinalRecalcularVazao"
                [showTime]="false" [showIcon]="true" dateFormat="dd/mm/yy"
                [maxDate]="dataMaxima" [minDate]="dataMinima"
                appendTo="body" placeholder="Data final (obrigatório)" [disabled]="loadingRecalcularVazao">
            </p-datepicker>
            <small class="p-text-secondary">O intervalo entre as datas não pode ser maior que 60 dias.</small>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" label="Cancelar" icon="pi pi-times"
            class="p-button-text" (click)="cancelarRecalcularVazao()" [disabled]="loadingRecalcularVazao"></button>
        <button pButton pRipple type="button" label="Recalcular" icon="pi pi-check"
            [disabled]="!dataInicialRecalcularVazao || !dataFinalRecalcularVazao || loadingRecalcularVazao"
            (click)="executarRecalcularVazao()" class="p-button-primary"></button>
        <p-progressSpinner *ngIf="loadingRecalcularVazao" [style]="{width: '28px', height: '28px'}"
            styleClass="custom-spinner" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
    </ng-template>
</p-dialog>

<!-- Modal de Período para Integração -->
<p-dialog header="Reprocessar Integração - Período" [(visible)]="modalPeriodoIntegracao" [modal]="true"
    [style]="{width: '50vw', maxWidth: '600px'}" [draggable]="false" [resizable]="false" [closable]="true"
    [dismissableMask]="true">

    <div class="p-fluid grid" *ngIf="estacaoReprocessamento">
        <div class="field col-12 mb-3">
            <label class="p-text-bold">Estação:</label>
            <p>{{estacaoReprocessamento.descricao}}</p>
        </div>

        <div class="field col-12">
            <label for="data_inicial_integracao" class="reprocessamento-date-label">Data inicial *</label>
            <p-datepicker inputId="data_inicial_integracao" [(ngModel)]="dataInicialIntegracao"
                [showTime]="false" [showIcon]="true" dateFormat="dd/mm/yy"
                [maxDate]="dataMaxima" [minDate]="dataMinimaIntegracao"
                appendTo="body" placeholder="Selecione a data">
            </p-datepicker>
            <small class="p-error">Data inicial é obrigatória.</small>
        </div>

        <div class="field col-12">
            <label for="data_final_integracao" class="reprocessamento-date-label">Data final *</label>
            <p-datepicker inputId="data_final_integracao" [(ngModel)]="dataFinalIntegracao"
                [showTime]="false" [showIcon]="true" dateFormat="dd/mm/yy"
                [maxDate]="dataMaxima" [minDate]="dataMinimaIntegracao"
                appendTo="body" placeholder="Selecione a data">
            </p-datepicker>
            <small class="p-text-secondary">
                Envio em background: data inicial 00:00:00, data final 23:59:59. Acompanhe o andamento no painel de reprocessamento.
            </small>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" label="Cancelar" icon="pi pi-times"
            class="p-button-text" (click)="cancelarPeriodoIntegracao()"></button>
        <button pButton pRipple type="button" label="Enfileirar" icon="pi pi-check"
            [disabled]="!dataInicialIntegracao || !dataFinalIntegracao || temConflitoIntegracaoAtivo()"
            (click)="processarIntegracao()"
            class="p-button-primary"></button>
    </ng-template>
</p-dialog>

<!-- Modal de Progresso de Integração -->
<p-dialog header="Reprocessar Integração - Progresso" [(visible)]="modalProgressoIntegracao" [modal]="true"
    [style]="{width: '50vw', maxWidth: '700px'}" [draggable]="false" [resizable]="false" [closable]="!processandoIntegracao"
    [dismissableMask]="!processandoIntegracao">

    <div class="p-fluid" *ngIf="estacaoReprocessamento">
        <div class="mb-3">
            <h5>Processando integração da estação: {{estacaoReprocessamento.descricao}}</h5>
        </div>

        <div class="field col-12 mb-3" *ngIf="processandoIntegracao">
            <div class="flex align-items-center justify-content-start">
                <p-progressSpinner [style]="{width: '30px', height: '30px'}" styleClass="custom-spinner"
                    strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
                <span class="ml-2">Aguardando processamento... O processamento pode levar até 10 minutos.</span>
            </div>
        </div>

        <div class="mb-3" *ngIf="concluidoIntegracao">
            <p [class.p-text-success]="resultadoIntegracaoTipo === 'success'" [class.p-text-warning]="resultadoIntegracaoTipo === 'warn'" class="p-text-bold">
                <span *ngIf="resultadoIntegracaoTipo === 'success'">✅ </span>
                <span *ngIf="resultadoIntegracaoTipo === 'warn'">⚠️ </span>
                {{ resultadoIntegracaoMensagem || 'Processamento concluído.' }}
            </p>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" label="Cancelar" icon="pi pi-times"
            class="p-button-text" (click)="cancelarProcessamentoIntegracao()"
            [disabled]="!processandoIntegracao"></button>
        <button pButton pRipple type="button" label="Fechar" icon="pi pi-check"
            (click)="fecharModalProgressoIntegracao()"
            [disabled]="processandoIntegracao" 
            *ngIf="concluidoIntegracao || !processandoIntegracao"
            class="p-button-success"></button>
    </ng-template>
</p-dialog>

<!-- Modal de confirmação de exclusão: digitar "Excluir estação" -->
<p-dialog header="Excluir estação?" [(visible)]="modalExcluirEstacao" [modal]="true"
    [style]="{width: '500px'}" [draggable]="false" [resizable]="false" [closable]="true"
    [dismissableMask]="false" (onHide)="fecharModalExcluirEstacao()">
    <div class="p-fluid" *ngIf="estacaoParaExcluir">
        <p class="mb-3">
            Deseja realmente excluir a estação <strong>{{ estacaoParaExcluir.descricao }}</strong> (código {{ estacaoParaExcluir.id }})?
        </p>
        <p class="mb-3">
            Para evitar exclusões acidentais, digite <strong>Excluir estação</strong> para confirmar.
        </p>
        <div class="field">
            <label for="input-excluir-estacao">Confirmação</label>
            <input id="input-excluir-estacao" type="text" pInputText
                [(ngModel)]="inputExcluirEstacao"
                placeholder="Excluir estação"
                [class.ng-invalid]="inputExcluirEstacao && inputExcluirEstacao !== textoConfirmacaoExclusaoEstacao" />
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" label="Cancelar" icon="pi pi-times"
            class="p-button-text" (click)="fecharModalExcluirEstacao()"></button>
        <button pButton pRipple type="button" label="Excluir" icon="pi pi-trash"
            class="p-button-danger"
            [disabled]="inputExcluirEstacao !== textoConfirmacaoExclusaoEstacao"
            (click)="executarExclusaoEstacao()"></button>
    </ng-template>
</p-dialog>

<p-dialog header="Credenciais do integrador" [(visible)]="showCredenciaisDialog" [modal]="true" [style]="{ width: '400px' }"
    [draggable]="false" [resizable]="false" (onHide)="showCredenciaisDialog = false">
    <div class="p-fluid">
        <div class="field" *ngIf="credenciaisIntegracao.label">
            <label>Integrador</label>
            <p class="p-m-0">{{ credenciaisIntegracao.label }}</p>
        </div>
        <div class="field">
            <label>Usuário</label>
            <p class="p-m-0">{{ credenciaisIntegracao.usuario || '—' }}</p>
        </div>
        <div class="field">
            <label>Senha</label>
            <p class="p-m-0">{{ credenciaisIntegracao.senha || '—' }}</p>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" label="Fechar" (click)="showCredenciaisDialog = false"></button>
    </ng-template>
</p-dialog>

<p-toast></p-toast>
